import { APPLY_POLICY_ADJUSTMENT } from '../../constants/actions/policy';

export function applyPolicyAdjustment(payload) {
    return {
        type: APPLY_POLICY_ADJUSTMENT,
        payload,
    };
}
